import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">萝卜影视</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              收录电视剧全集、连续剧完整版及电视剧大结局，在线全集免费看，无需等待更新，一次追完整部剧。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">分类浏览</h4>
            <ul className="space-y-2">
              {categories.filter((c) => c.slug !== 'all').slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@luobotv.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-foreground-700/50 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} 萝卜影视 luobotv.com 版权所有
          </p>
          <div className="flex items-center gap-6 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}